<template>
  <div class="w3-container contact-container">
    <h1 class="w3-xxxlarge"><b>{{ $t('Contact') }}</b></h1>
    <hr class="w3-round">
    <div v-html="$t('Contact us text')"></div>


    <iframe
      class="google-maps"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2742.284948698673!2d20.679353634592207!3d46.58160401237761!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47443c2961aae753%3A0x458fc61ebcfac3d3!2sOrosh%C3%A1za%2C%20Juh%C3%A1sz%20Gyula%20u.%2020%2C%205900%20Hungary!5e0!3m2!1sen!2sus!4v1677170241840!5m2!1sen!2sus"
      frameborder="0"
      allowfullscreen>
    </iframe>

    <!--Töltse ki az űrlapot és felvesszük önnel a kapcsolatot!-->

    <!--<form>
      <div class="w3-section">
        <label>Név</label>
        <input class="w3-input w3-border" type="text" name="name" required>
      </div>
      <div class="w3-section">
        <label>Email</label>
        <input class="w3-input w3-border" type="text" name="email" required>
      </div>
      <div class="w3-section">
        <label>Üzenet</label>
        <input class="w3-input w3-border" type="text" name="message" required>
      </div>
      <button class="w3-button w3-block w3-padding-large w3-pink w3-margin-bottom">Üzenet küldése</button>
    </form> -->
  </div>
</template>

<i18n>
  {
    "de": {
      "Contact": "Kontakt",
      "Contact us text": "<p>Möchten Sie Ihr Zuhause umgestalten lassen?<br>Unser Team steht Ihnen zur Verfügung, wenn Sie eine konkrete Vorstellung haben, die nur umzusetzen ist, oder auch, falls Sie sich nur erkundigen möchten oder eine Beratung ohne Einschränkungen brauchen.</p> <p>Alexy Üvegtechnika Orosháza Kft.<br> 5900 Orosháza, Juhász Gyula u. 5091/1 Pz., Ungarn<br> +36 20 330 0518 • info@becreative.glass</p>"
    },
    "en": {
      "Contact": "Contact",
      "Contact us text": "<p>Do you want us to design your home?<br> Our team is gladly at your service, regardless, if it is a concrete idea, which is only waiting for the implentation, or if it is only interest, or maybe a consultation free from any compulsion.</p> <p>Alexy Üvegtechnika Orosháza Kft.<br> 5091/1, Juhász Gyula St, Orosháza 5900, Hungary<br> +36 20 330 0518 • info@becreative.glass</p>"
    },
    "hu": {
      "Contact": "Kapcsolat",
      "Contact us text": "<p>Szeretné, ha megformálnánk otthonát?<br> Csapatunk készséggel áll a rendelkezésére, legyen az egy konkrét elképzelés, ami már csak a megvalósításra vár, vagy csupán érdeklődés, esetleg egy kötöttségektől mentes konzultáció.</p> <p>Alexy Üvegtechnika Orosháza Kft.<br> 5900 Orosháza, Juhász Gyula u. 5091/1 hrsz.<br> +36 20 330 0518 • info@becreative.glass</p>"
    }
  }
</i18n>

<script>
  export default {
    name: 'contactContent',
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
    },
  };

</script>


<style scoped>
  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

  form {
    max-width: 1000px;
  }

  .google-maps {
    border: 0;
    width: 100%;
    height: 500px;
    border: 0;
  }

  .contact-container {
    margin-top: 75px;
    max-width: 1000px;
  }
 </style>



// WEBPACK FOOTER //
// ContactContent.vue?dc0d2b68